import store from "../localStorage";
import {SET_TEMPLATE, SAVE_EMPLOYEES, SET_EMPLOYEE_PROPS, SET_STRUCTURE, SAVE_VIEW_SETTINGS, SET_INTERVALS, SET_SHOW_INTERVALS, SET_MY_INTERVALS} from "./lamp";

export default class lampManage {
    static setTemplateLamp = (template) => store.dispatch({type: SET_TEMPLATE, template: template});
    static saveEmployees = (employees) => store.dispatch({type: SAVE_EMPLOYEES, employees: employees});
    static setShowIntervals = (show_intervals) => store.dispatch({type: SET_SHOW_INTERVALS, show_intervals: show_intervals});
    static setIntervals = (intervals) => store.dispatch({type: SET_INTERVALS, intervals: intervals});
    static setMyIntervals = (my_intervals) => store.dispatch({type: SET_MY_INTERVALS, my_intervals: my_intervals});
    static saveEmployeeProps = (employee_properties) => store.dispatch({type: SET_EMPLOYEE_PROPS, employee_properties: employee_properties});
    static saveStructure = (structures) => {
        const toTree = require('./../helpers/functions').toTree;
        let tree_structures = toTree(structures);
        store.dispatch({type: SET_STRUCTURE, structures: tree_structures});
    }
    static saveViewSettings = (settings) => store.dispatch({type: SAVE_VIEW_SETTINGS, view_settings: settings});
}
